<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />

        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="exportDeductionsCsv"
                    ><i class="ti ti-file-type-xls me-1"></i>Export as CSV</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="exportDeductionsExcel"
                    ><i class="ti ti-file-spreadsheet me-1"></i>Export as Excel</a
                  >
                </li>
              </ul>
            </div>
          </div>

          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- TOP FILTERS -->
      <div class="d-flex justify-content-between my-4">
        <div class="payroll-btns">
          <router-link to="/payroll/payroll" class="btn btn-white border me-2">
            Payments
          </router-link>
          <router-link
            to="/payroll/payroll-overtime"
            class="btn btn-white border me-2"
          >
            Overtime
          </router-link>
          <router-link
            to="/payroll/payroll-deduction"
            class="btn btn-white active border me-2"
          >
            Deductions
          </router-link>
          <router-link
            to="/payroll/period-adjustments"
            class="btn btn-white border"
          >
            Optional Monthly Adjustments
          </router-link>
        </div>

        <div class="mb-2">
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#add_deduction"
            class="btn btn-primary d-flex align-items-center"
            @click="onAddNew"
            v-can="'Payroll.Create'"
          >
            <i class="ti ti-circle-plus me-2"></i>Add Deduction
          </a>
        </div>
      </div>

      <!-- TABLE CARD -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Deductions List</h5>

          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Type : {{ typeFilterLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="typeFilter = 'all'"
                    >All Types</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="typeFilter = 'fixed'"
                    >Fixed</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="typeFilter = 'unit'"
                    >Unit-based</a
                  >
                </li>
              </ul>
            </div>

            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : {{ sortLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="sortOption = 'recent'"
                    >Recently Added</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="sortOption = 'name_asc'"
                    >Name A-Z</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="sortOption = 'name_desc'"
                    >Name Z-A</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="sortOption = 'amount_desc'"
                    >Highest Amount</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- TABLE -->
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="tableData"
              :row-selection="rowSelection"
              :loading="loading"
              row-key="id"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'name'">
                  <h6 class="fs-14 fw-medium text-gray-9">{{ record.name }}</h6>
                </template>

                <template v-else-if="column.key === 'amount'">
                  <span>{{ record.amount }}</span>
                </template>

                <template v-else-if="column.key === 'is_unit_calculation'">
                  <span
                    class="badge"
                    :class="
                      record.is_unit_calculation
                        ? 'bg-success-subtle text-success'
                        : 'bg-secondary-subtle text-muted'
                    "
                  >
                    {{ record.is_unit_calculation ? "Unit-based" : "Fixed" }}
                  </span>
                </template>

                <template v-else-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#add_deduction"
                      @click="onEdit(record)"
                      v-can="'Payroll.Edit'"
                    >
                      <i class="ti ti-edit"></i>
                    </a>
                    <a href="javascript:void(0);" @click="onDelete(record)" v-can="'Payroll.Delete'">
                      <i class="ti ti-trash"></i>
                    </a>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /TABLE CARD -->
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>

  <payroll-deduction-modal
    ref="deductionModal"
    @refresh="fetchAll"
  ></payroll-deduction-modal>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { storeToRefs } from "pinia";
import { usePayrollDeductionStore } from "@/stores/payrollDeductionStore";
import { exportRowsAsCsv, exportRowsAsExcel } from "@/utils/payrollListExport";

// TEXTS
const title = ref("Payroll Components");
const text = ref("Payroll Company Settings");
const text1 = ref("Deductions");
const sortOption = ref("recent");
const typeFilter = ref("all");

// TABLE CONFIG
const columns = [
  { sorter: false },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "Default/Unit Amount",
    dataIndex: "amount",
    key: "amount",
    sorter: (a, b) => (a.amount || 0) - (b.amount || 0),
  },
  {
    title: "Type",
    dataIndex: "is_unit_calculation",
    key: "is_unit_calculation",
  },
  { title: "", key: "action", sorter: false },
];

const filteredDeductions = computed(() => {
  const list = Array.isArray(deductions.value) ? [...deductions.value] : [];

  const typed = list.filter((item) => {
    if (typeFilter.value === "unit") return !!item.is_unit_calculation;
    if (typeFilter.value === "fixed") return !item.is_unit_calculation;
    return true;
  });

  switch (sortOption.value) {
    case "name_asc":
      return typed.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    case "name_desc":
      return typed.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
    case "amount_desc":
      return typed.sort((a, b) => Number(b.amount || 0) - Number(a.amount || 0));
    default:
      return typed.sort(
        (a, b) =>
          new Date(b.created_at || 0).getTime() -
          new Date(a.created_at || 0).getTime(),
      );
  }
});

const tableData = computed(() => {
  return filteredDeductions.value.map((d) => ({
    _raw: d,
    id: d.id,
    key: d.id,
    name: d.name,
    amount: d.amount,
    is_unit_calculation: d.is_unit_calculation,
    employee_ids: d.employee_ids,
    assignee_type: d.assignee_type,
  }));
});

const sortLabel = computed(() => {
  switch (sortOption.value) {
    case "name_asc":
      return "Name A-Z";
    case "name_desc":
      return "Name Z-A";
    case "amount_desc":
      return "Highest Amount";
    default:
      return "Recently Added";
  }
});

const typeFilterLabel = computed(() => {
  switch (typeFilter.value) {
    case "unit":
      return "Unit-based";
    case "fixed":
      return "Fixed";
    default:
      return "All Types";
  }
});

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

// MODAL REF
const deductionModal = ref(null);

// STORE
const store = usePayrollDeductionStore();
const { deductions, loading } = storeToRefs(store);
const { fetchAll, deleteDeduction } = store;

// INITIAL LOAD
onMounted(() => {
  fetchAll();
});

// METHODS
const toggleHeader = () => {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
};

const onAddNew = () => {
  deductionModal.value?.resetForm();
};

const onEdit = (record) => {
  deductionModal.value?.openForEdit(record);
};

const onDelete = async (record) => {
    deductionModal.value?.openForDelete(record);
};

const exportDeductionsCsv = () => {
  exportRowsAsCsv(
    "payroll-deductions.csv",
    ["Name", "Amount", "Type", "Assignment"],
    filteredDeductions.value.map((item) => [
      item.name,
      item.amount ?? 0,
      item.is_unit_calculation ? "Unit-based" : "Fixed",
      item.assignee_type || "all",
    ]),
  );
};

const exportDeductionsExcel = () => {
  exportRowsAsExcel(
    "payroll-deductions.xls",
    ["Name", "Amount", "Type", "Assignment"],
    filteredDeductions.value.map((item) => [
      item.name,
      item.amount ?? 0,
      item.is_unit_calculation ? "Unit-based" : "Fixed",
      item.assignee_type || "all",
    ]),
  );
};
</script>


